module.exports = "../fonts/viber_authorize.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/viber_authorize.svg
// module id = 215
// module chunks = 0